<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.provenance')"
    resource="provenances"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class Provenances extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('provenance.name'),
        renderCell: {
          component: 'input'
         }
      },
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'name',
        label: this.$t('provenance.name'),
      },
      type === 'show' && {
        prop: 'cities',
        label: this.$t('provenance.cities'),
        renderCell(h, { props: { value } }) {
          if (value.length) {
            return value.map((city) => <div>{city.name}</div>)
          } else {
            return <span>/</span>
          }
        }
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
    ].filter(Boolean)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data }) {
    return [
      {
        prop: 'name',
        label: this.$t('provenance.name'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'city_ids',
        label: this.$t('provenance.cities'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            options: _.map(data.cities, (value) => ({ label: value.name, value: value.id })),
            multiple: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/cities', { params: { per_page: 100, province_country_iso3_eq: 'ITA', order: { id: 'asc' } } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword, province_country_iso3_eq: 'ITA', order: { id: 'asc' } };
              const { data } = await this.$request.get('/cities', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      }
    ]
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'provenances.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'provenances.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/provenances',
    name: 'provenances.index',
    component: Provenances,
    props: {
      type: 'index',
    }
  },
  {
    path: '/provenances/new',
    name: 'provenances.new',
    component: Provenances,
    props: {
      type: 'new',
    }
  },
  {
    path: '/provenances/:id',
    name: 'provenances.show',
    component: Provenances,
    props: {
      type: 'show',
    }
  },
  {
    path: '/provenances/:id/edit',
    name: 'provenances.edit',
    component: Provenances,
    props: {
      type: 'edit'
    }
  }
]
</script>
